import * as React from "react";
import { graphql } from 'gatsby';
import PostLink from '../components/post-link';
import Seo from "../components/seo";

const CategoryPosts = ({ data, pageContext }) => {
  const categoryPosts = data.allMdx.edges;
  return (
    <React.Fragment>
      <Seo title={pageContext.category} />
      {
        <>
        <h1>{pageContext.category}</h1>
        {categoryPosts.map((edge) => (
          <article key={edge.node.id}>
            <PostLink
              link={edge.node.fields.categoryPostPath}
              title={edge.node.frontmatter.title}
              date={edge.node.frontmatter.date}
            />
          </article>
        ))}
        </>
      }
    </React.Fragment>
  )
}

export default CategoryPosts;

export const query = graphql`
  query ($category: String) {
    allMdx(
      sort: {fields: frontmatter___date, order: DESC}
      filter: {frontmatter: {category: {eq: $category}}}
      ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM D, YYYY")
            category
          }
          fields {
            categoryPostPath
          }
        }
      }
    }
  }
`;
